import { useEffect } from 'react';
import { useFormContext } from "react-hook-form";
import { motion, AnimatePresence } from "framer-motion";

type FormCheckboxProps = {
    name: string;
    label: string | React.ReactNode;
    value?: string | number; // Add value prop
    onError?: any;
    className?: string;
    readonly?: boolean;
    textClassName?: string;
    required?: string;
};


const FormCheckbox = ({
    name,
    label,
    value,
    className,
    onError,
    required,
    textClassName,
    readonly
}: FormCheckboxProps) => {
    const { register, formState } = useFormContext();
    const error = formState.errors[name]?.message as string | undefined;

    useEffect(() => {
        if (onError) {
            onError(error);
        }
    }, [error]);

    return (
        <div className={`flex flex-col items-start ${className}`}>
            <label className="flex space-x-2">
                <input
                    type="checkbox"
                    value={value}
                    readOnly={readonly}
                    disabled={readonly}
                    {...register(name, { required })}
                    className={`w-5 h-5 text-blue-600 rounded focus:ring-blue-500 ${error ? 'border-2 border-[#FD355A]' : 'border-gray-300'}`}
                />
                <span className={`text-gray-600 ${textClassName}`}>{label}</span>
            </label>

            <AnimatePresence>
                {error && (
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        className="text-[#FD355A] text-md font-bold mt-1"
                    >
                        {error}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default FormCheckbox;
